import { render, staticRenderFns } from "./ResourcePreview.modal.vue?vue&type=template&id=1ebbc7d3"
import script from "./ResourcePreview.modal.vue?vue&type=script&lang=ts"
export * from "./ResourcePreview.modal.vue?vue&type=script&lang=ts"
import style0 from "./ResourcePreview.modal.vue?vue&type=style&index=0&id=1ebbc7d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports